import { useQuery, useMutation } from "./useApi.js";
import { syncersService, type JobRunsQueryParams, type JobType } from "../api/syncers.service.js";

/**
 * Hook to fetch syncer job runs with optional filtering
 */
export function useSyncerRuns(params: JobRunsQueryParams) {
  return useQuery(
    () => syncersService.getJobRuns(params),
    [params.jobType, params.status, params.offset, params.limit],
  );
}

/**
 * Hook to fetch a single job run by ID
 */
export function useSyncerRun(runId: string | null) {
  return useQuery(() => (runId ? syncersService.getJobRun(runId) : Promise.resolve(null)), [runId]);
}

/**
 * Hook to trigger a new syncer job
 */
export function useTriggerSyncerJob() {
  return useMutation(
    (params: { jobType: JobType; triggeredBy?: string; extra?: Record<string, unknown> }) =>
      syncersService.triggerJob(params.jobType, params.triggeredBy, params.extra),
  );
}
